import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';
import { RoomDetailJson, ShowUserInfo } from '@/views/Voice/typings';

export interface RoomInfoState {
  mainRoomInfo: any;
  mainRoomId: number;
  roomId: number;
  roleId: number;
  modelType: number;
  roomNum: number;
  diffTime: number;
  micReload: number;
  micStatus: boolean;
  isMic: boolean;
  isAllBanned: boolean;
  banMsg: boolean;
  kickOutTime: string;
  isConnectIm: boolean;
  hxRoomId: number;
  chatInterval: number;
  tourBanChat: boolean;
  roomDetail?: RoomDetailJson;
  svip_effect?: any;
  userId: number;
  user_96show?: ShowUserInfo;
  firstEnterPkLive?: boolean;
  ctime?: number;
}

const LOCALKEY = localKeyInfo.roomInfo;
const localVoiceInfo = LocalStore.getValue<RoomInfoState>(LOCALKEY) || {};

export const roomInfo: RoomInfoState = {
  mainRoomInfo: null,
  mainRoomId: 0,
  roomId: 0,
  roleId: 0,
  modelType: 2,
  roomNum: 0,
  diffTime: 0,
  micReload: 0,
  micStatus: false,
  isMic: false,
  isAllBanned: false,
  banMsg: false,
  kickOutTime: '',
  hxRoomId: 0,
  chatInterval: 0,
  tourBanChat: false,
  roomDetail: undefined,
  isConnectIm: false,
  svip_effect: undefined,
  userId: 0,
  firstEnterPkLive: false,
  ctime: 0,
  ...localVoiceInfo
};

export const setRoomInfo: (payload: RoomInfoState) => IAction<RoomInfoState> = (payload: RoomInfoState) => ({
  type: 'setRoomInfo',
  payload
});

const roomInfoReducer: Reducer<RoomInfoState, IAction<any>> = (state = roomInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setRoomInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default roomInfoReducer;
